<div class="container">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>View Purchase Orders</h2>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex gap-3">
      <div class="form-floating me-2">
        <select class="form-select" id="financialYearSelect" [(ngModel)]="selectedFinancialYear"
          (change)="applyFilters()" aria-label="Financial Year">
          <option value="" disabled selected hidden></option>
          <option value="all">ALL</option>
          <option *ngFor="let year of financialYears" [value]="year">{{ year }}</option>
        </select>
        <label for="financialYearSelect">Financial Year</label>
      </div>

      <div class="form-floating">
        <select class="form-select" id="poStatusSelect" [(ngModel)]="selectedPurchaseOrderStage"
          (change)="filterByStatus()" aria-label="Purchase Order Status">
          <option value="" disabled selected hidden></option>
          <option *ngFor="let stage of purchaseOrderStages" [value]="stage">
            {{ stage.toUpperCase() }}
          </option>
        </select>
        <label for="poStatusSelect">PO Status</label>
      </div>

    </div>


    <button (click)="exportToExcel()" class="btn btn-success btn-sm">
      <i class="fa fa-file-excel"></i>Export to Excel</button>
  </div>
  <div class="custom-table-wrapper">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>PO #</th>
          <th>Assigned To</th>
          <th>Date</th>
          <th>Vendor</th>
          <th>Value</th>
          <th>Actions</th>
        </tr>
        <!-- Filtering Row -->
        <tr>
          <th><input type="text" class="form-control" placeholder="Search PO #" [(ngModel)]="filter.poId"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Assigned To" [(ngModel)]="filter.assignedTo"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Date" [(ngModel)]="filter.date"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Vendor" [(ngModel)]="filter.vendor"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Value" [(ngModel)]="filter.value"
              (input)="applyFilters()" /></th>
          <th>
            <button (click)="resetFilters()" class="btn btn-primary btn-sm">
              <i class="fa fa-x" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let po of filteredPurchaseOrderData">
          <td>{{ (po.purchaseOrderFields.purchaseOrderId) }}</td>
          <td>{{
            purchaseOrderCommonServices?.getAssignedToName(po.purchaseOrderFields.purchaseOrderAssignedToId)?.username
            || '-'
            }}</td>
          <td>{{ po.purchaseOrderFields.purchaseOrderDate | date:'dd/MM/yyyy' }}</td>
          <td>{{ purchaseOrderCommonServices?.getVendorName(po.purchaseOrderFields.purchaseOrderVendorId)?.vendorName
            || '-' }}
          </td>
          <td>{{ po.purchaseOrderFields.grandTotal }}</td>
          <td>
            <button (click)="editPurchaseOrder(po)" class="btn btn-primary btn-sm"
              [disabled]="!hasPermission('PurchaseOrdersAddNewPermission')">
              <i class="fa fa-edit" aria-hidden="true"></i>
            </button>
            <button (click)="viewPurchaseOrder(po)" class="btn btn-primary btn-sm">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </button>
            <button (click)="deletePurchaseOrder(po)" class="btn btn-danger btn-sm">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>